class HashTable<T, K> {
    private keys: T[] = [];
    private values: K[] = [];
    public put(key: T, value: K) {
        const index = this.keys.indexOf(key);
        if (index === -1) {
            this.keys.push(key);
            this.values.push(value);
        } else {
            this.values[index] = value;
        }
    }
    public get(key: T) {
        return this.values[this.keys.indexOf(key)];
    }
}

export default HashTable;
